import React from 'react';
import { personalInfo } from '../data';
import './Contact.css';

const Contact = () => {
  const contacts = [
    {
      label: 'Email',
      value: personalInfo.email,
      link: `mailto:${personalInfo.email}`,
    },
    {
      label: 'Phone',
      value: personalInfo.phone,
      link: `tel:${personalInfo.phone.replace(/\s/g, '')}`,
    },
    {
      label: 'LinkedIn',
      value: 'dhruv-singh',
      link: personalInfo.linkedin,
      external: true,
    },
    {
      label: 'GitHub',
      value: 'dhruv1122',
      link: personalInfo.github,
      external: true,
    },
  ];

  return (
    <section className="contact" id="contact">
      <div className="section-header">
        <div>
          <h2 className="section-title">Get in Touch</h2>
          <p className="section-subtitle">Let's connect and discuss opportunities</p>
        </div>
      </div>

      <div className="contact-grid">
        {contacts.map((contact, index) => (
          <a
            key={index}
            href={contact.link}
            className="contact-card"
            target={contact.external ? '_blank' : undefined}
            rel={contact.external ? 'noopener noreferrer' : undefined}
          >
            <div className="contact-label">{contact.label}</div>
            <div className="contact-value">{contact.value}</div>
          </a>
        ))}
      </div>
    </section>
  );
};

export default Contact;
